import React from 'react';
import Radium from 'radium';

import {Button, A} from 'views/AppElements';

import LoginSignUpBox from 'views/user/LoginSignUpBox';

import AppMenu, {DropDownNav} from 'views/AppMenu';

import { Sticky } from 'react-sticky';
import AppUtil from 'AppUtil';
import AppSideBar from './AppSideBar';

const styles = {
	header: {background: "rgb(245, 245, 245)", alignItems: 'center', paddingTop: '10px'}
};


class Header extends React.Component {
		
	constructor(props) {
		super(props);
		this.openLoginModal = this.openLoginModal.bind(this);
		this.openSideBar = this.openSideBar.bind(this);
		this.toogleSideBar = this.toogleSideBar.bind(this);

		const forceOpenLogin = this.props.forceOpenLogin;
		this.state = {openLoginModal: forceOpenLogin !== null && forceOpenLogin.selectedForm !== null,
						openSideBar: false};
	}

	static getDerivedStateFromProps(props, currentState) {
		if(props.forceOpenLogin !== null && props.forceOpenLogin.selectedForm !== null) {
			currentState.openLoginModal = true;
			return currentState;
		}

	    if(props.session)
	    	currentState.openLoginModal = false;

	    return currentState;
  	}

	openLoginModal() {
		this.setState({openLoginModal: true});
	}

	toogleSideBar() {
		this.setState({openSideBar: !this.state.openSideBar});
	}

	openSideBar() {
		this.setState({openSideBar: true});
	}

	render() {
		const session = this.props.session;
		const forceOpenLogin = this.props.forceOpenLogin;
		const popularStores = this.props.popularStores;
		const influencers = this.props.influencers;
		
		const logoImg = AppUtil.getAppLogo();

		return (
				<div style={[styles.header]}  id="header">
					<div className='scWidth flexRow' style={{justifyContent: 'space-between'}}>
						<A href="/" style={{margin: '5px 0', '@media (max-width: 770px)':{margin: '5px auto'}}}>
							<img src={logoImg} alt="Seto Canvas" style={{width: '300px', cursor: 'pointer', 
									'@media (max-width: 770px)': {display: 'none'}}}/>
						</A>
						

						<div className="flexColumn" style={{'@media (max-width: 500px)':{width: '100%'}}}>

							<div id="specialButtons" className="flexRow" style={{margin: '10px 0'}}>
								
							{
								session === null &&
								<div style={{flexGrow: '1', margin: '0 10px'}} key='leftAligned'>
									<Button href="/artist/signup" mui='true' color='primary'
											style={{width: '100%'}}>
										<i className="fa fa-user-circle" aria-hidden="true"></i> Join Seto Canvas
									</Button>
								</div>
							}
								

							{
							session !== null &&
							<div style={{flexGrow: '1', margin: '0 10px'}} key='leftAligned'>
								<Button href="/design/submit" mui='true' color='primary' style={{width: '100%'}}>
									<i className="fa fa-cloud-upload" aria-hidden="true"></i> Submit Artwork
								</Button>
							</div>
							}
								

								<div style={{flexGrow: '1', textAlign: 'center', 
											'@media (max-width: 770px)':{margin: '0 10px'}}} key='rightAligned'>
									{
										session === null &&
										<Button onClick={this.openLoginModal} mui='true' style={{width: '100%'}} ><i className="fa fa-lock" aria-hidden="true"></i> Sign In</Button>
									}

									{
										session !== null &&
										<DropDownNav  session={session} />
									}
								</div>
							</div>
						</div>
						<LoginSignUpBox openLoginModal={this.state.openLoginModal} 
										selectedForm={forceOpenLogin !== null? forceOpenLogin.selectedForm: null}
										formData={forceOpenLogin !== null? forceOpenLogin.formData: null} />
					</div>
						
						
					<AppSideBar influencers={influencers} popularStores={popularStores} 
								openSideBar={this.state.openSideBar} toogleSideBar={this.toogleSideBar}
									/>
				
					<Sticky topOffset={this.props.turnOffSticky === true? 1100000000: 110}>
						{({style, isSticky}) => {
							if(isSticky)
								style = Object.assign({}, style, {borderBottom: '1px dashed rgb(61, 61, 61)'})
							return <AppMenu style={style} isSticky={isSticky} 
										influencers={influencers}
										popularStores={popularStores} 
										onNavBarToggle={this.openSideBar} />
						}}
					</Sticky>	
				</div>
		);
	}
}

export default Radium(Header);


// WEBPACK FOOTER //
// ./src/views/Header.js